import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import SurveyIframe, { SurveyAction } from './SurveyIframe';

const TurnOffAutoRenewDialog = (
  {
    showDialog,
    handleCloseDialog,
    toggleAutoRenew,
  }: {
    showDialog: boolean,
    handleCloseDialog: () => void,
    toggleAutoRenew: () => void,
  },
) => {
  const handleSurveyClose = (action: SurveyAction) => {
    if (action === SurveyAction.FINISH) {
      toggleAutoRenew();
    } else if (action === SurveyAction.CANCEL) {
      handleCloseDialog();
    }
  };

  return (
    <Dialog
      open={showDialog}
      id="cancel-order-dialog"
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          padding: 0,
          borderRadius: 1.5,
          maxWidth: '560px',
          maxHeight: '680px',
          width: '100%',
          height: '100%',
        },
      }}
    >
      <DialogContent
        id="turn-off-auto-renewal-survey-dialog-content"
        key="turn-off-auto-renewal-survey-dialog-content"
        sx={{
          padding: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {showDialog && (
          <SurveyIframe
            handleSurveyClose={handleSurveyClose}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TurnOffAutoRenewDialog;
